import type { ComponentProps } from 'react'
import Svg, { Path } from 'react-native-svg'

export function BookTravel(props: ComponentProps<typeof Svg>) {
  return (
    <Svg width={63} height={63} viewBox="0 0 63 63" fill="none" {...props}>
      <Path d="M0 8a8 8 0 018-8h47a8 8 0 018 8v47a8 8 0 01-8 8H8a8 8 0 01-8-8V8z" fill="#C6FFF5" />
      <Path
        d="M41.54 44.333l-3.167-14.427 6.158-6.159c2.64-2.639 3.519-6.158 2.64-7.917-1.76-.88-5.28 0-7.918 2.64l-6.159 6.157-14.427-3.167c-.88-.176-1.584.176-1.935.88l-.528.88c-.352.88-.176 1.759.528 2.287l9.325 6.158-3.52 5.278H17.26l-1.76 1.76 5.278 3.519 3.52 5.278 1.759-1.76v-5.278l5.278-3.519 6.158 9.325c.528.704 1.408.88 2.287.528l.88-.352c.704-.528 1.056-1.231.88-2.111z"
        fill="#00DFC9"
        stroke="#223843"
        strokeWidth={3}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Svg>
  )
}
